var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<p ng-switch=\"$ctrl.type\"><b ng-switch-when=\"currency\">{{$ctrl.value | currency}}</b><b ng-switch-when=\"date\">{{$ctrl.value | momentToDate | date}}</b><b ng-switch-when=\"work-date\">{{$ctrl.value | momentToDate | date}}</b><b ng-switch-default>{{$ctrl.value}}</b></p><icon name=\"minus-white\" ng-click=\"$ctrl.minus()\" class=\"minus-icon\"></icon><icon name=\"plus-white\" ng-click=\"$ctrl.plus()\" class=\"plus-icon\"></icon>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/components/od-incrementor.jade
 ** module id = 3484
 ** module chunks = 3
 **/